/* MOOOD UX fixes (theme-8). Loaded after theme.js; theme.js itself is untouched.
   1) Replays add-to-cart taps made before the theme scripts were ready (no more jump to /cart).
   2) Every add shows a light pill (no sheet, no cart page), so shoppers keep browsing. */
(function () {
  'use strict';
  var T = window.theme || {};
  var SEEN = 'moood-upsell-seen';
  var ar = T.locale !== 'en';

  function seen() { try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(SEEN, '1'); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function money(cents) {
    var v = cents / 100;
    var n = (Math.round(v * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return n + ' ' + (T.currencyLabel || '');
  }

  /* The sheet is on for this add: remember it so the next adds use the pill. */
  var sheet = document.getElementById('UpsellSheet');
  if (sheet && 'MutationObserver' in window) {
    new MutationObserver(function () { if (sheet.classList.contains('is-open')) markSeen(); })
      .observe(sheet, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Light pill ---------- */
  var pill, pillTimer;
  function hidePill(ms) {
    clearTimeout(pillTimer);
    pillTimer = setTimeout(function () { if (pill) pill.classList.remove('is-in'); }, ms);
  }
  function showPill(src) {
    if (!pill) {
      pill = document.createElement('div');
      pill.className = 'added-pill';
      pill.setAttribute('role', 'status');
      pill.setAttribute('aria-live', 'polite');
      document.body.appendChild(pill);
      pill.addEventListener('mouseenter', function () { clearTimeout(pillTimer); });
      pill.addEventListener('mouseleave', function () { hidePill(2500); });
      pill.addEventListener('click', function (e) {
        if (e.target.closest('[data-pill-close]')) hidePill(0);
        else if (e.target.closest('[data-cart-open]')) hidePill(0);
      });
    }
    var inner = document.querySelector('[data-cart-drawer-inner]');
    var count = inner ? parseInt(inner.dataset.count, 10) || 0 : 0;
    var total = inner ? parseInt(inner.dataset.total, 10) || 0 : 0;
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var threshold = Math.round((T.freeShippingThreshold || 0) * rate);
    var ship = '';
    if (threshold && T.strings) {
      var left = Math.max(0, threshold - total);
      ship = left === 0 ? T.strings.freeShippingDone : String(T.strings.freeShippingRemaining || '').replace('[amount]', money(left));
    }
    pill.innerHTML =
      (src ? '<span class="added-pill__media"><img src="' + esc(src) + '" alt=""></span>' : '') +
      '<span class="added-pill__txt"><strong>' + (ar ? 'تمت الإضافة للسلة' : 'Added to bag') + '</strong>' +
        (ship ? '<small>' + esc(ship) + '</small>' : '') + '</span>' +
      '<a href="' + esc((T.routes && T.routes.cart) || '/cart') + '" class="added-pill__btn" data-cart-open>' +
        (ar ? 'السلة' : 'Bag') + ' (' + count + ')</a>' +
      '<button type="button" class="added-pill__x" data-pill-close aria-label="' + (ar ? 'إغلاق' : 'Close') + '">&times;</button>';
    pill.classList.remove('is-in'); void pill.offsetWidth; pill.classList.add('is-in');
    hidePill(4200);
  }

  function bumpCount() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.remove('is-bumping'); void el.offsetWidth; el.classList.add('is-bumping');
      setTimeout(function () { el.classList.remove('is-bumping'); }, 700);
    });
  }

  function quickAdd(form) {
    var btn = form.querySelector('[type="submit"]');
    var errBox = form.querySelector('[data-form-error]');
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    var list = ['cart-drawer'];
    if (document.querySelector('[data-main-cart]')) list.push('main-cart');
    fd.append('sections', list.join(','));
    fd.append('sections_url', location.pathname);
    fetch(((T.routes && T.routes.cartAdd) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    }).then(function (res) {
      if (!res.ok || res.data.status) {
        var msg = (res.data && (res.data.description || res.data.message)) || (T.strings && T.strings.cartError) || 'Error';
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else if (T.toast) T.toast(msg);
        return;
      }
      if (T.renderCartSections) T.renderCartSections(res.data.sections);
      if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2400); }
      bumpCount();
      document.dispatchEvent(new CustomEvent('moood:cart-added', { detail: res.data }));
      var card = form.closest('[data-product-card]');
      var img = card ? card.querySelector('.card__media img:not(.card__img--hover)') : document.querySelector('.gallery__slide.is-active img, .gallery__slide img');
      showPill((img && (img.currentSrc || img.src)) || res.data.image || '');
    }).catch(function () {
      if (T.toast) T.toast((T.strings && T.strings.cartError) || 'Error');
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }

  /* Runs before theme.js's own submit handler (window capture phase). */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-cart]') || !window.fetch) return;
    if (T.cartType === 'page') return; // every add stays on the page: light pill only, no sheet, no cart page
    e.preventDefault();
    e.stopImmediatePropagation();
    quickAdd(f);
  }, true);

  /* Replay taps that were held by the inline guard in theme.liquid. */
  window.__mReady = true;
  var held = window.__mq || [];
  window.__mq = [];
  held.filter(function (f, i) { return held.indexOf(f) === i && document.contains(f); }).forEach(function (f) {
    var b = f.querySelector('[type="submit"]');
    if (b) b.classList.remove('is-loading');
    if (f.requestSubmit) f.requestSubmit(b || undefined); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });
})();
